import React from "react";
import {
  Typography,
  Box,
  ListItemText,
  ListItem,
  ListItemIcon,
  List,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import { useTheme } from "@mui/material/styles";
import { v4 as uuidv4 } from "uuid";

import { shortenAddress } from "../../utils/Helpers";
import { boxClasses } from "../../utils/classes";
import { OutlinedButton, Button } from "../../components/Button";
import { height, margin, maxHeight, positions } from "@mui/system";

const listItems = [
  "You will not be able to cancel the transaction once you submit it",
  "Your transaction could get stuck for an indefinite amount of time",
  "Funds cannot be returned if they are sent to the wrong address.",
  "The transaction fee may be higher than expected.",
];

interface IPreflightModalTransferProps {
  open: boolean;
  close: () => void;
  sender: string;
  receiver: string;
  value: number;
  tokenSymbol: string;
  sourceNetwork: string;
  targetNetwork: string;
  start: () => void;
}

const PreflightModalTransfer: React.FC<IPreflightModalTransferProps> = ({
  open,
  close,
  receiver,
  sender,
  sourceNetwork,
  targetNetwork,
  tokenSymbol,
  value,
  start,
}: IPreflightModalTransferProps) => {
  const theme = useTheme();

  const [isAgree, setIsAgree] = React.useState(false);
  const classes = {
    ...boxClasses,
    // maxHeight: "788px",
    // height: "100%",
    position: "relative",
    margin: "auto",
  };
  return (
    <Box
      sx={classes}
      // maxHeight="788px"
      // height="100%"
      position="relative"
      margin="auto"
    >
      <Typography
        variant="h3"
        component="h3"
        fontSize={24}
        color={theme.palette.text.primary}
        textAlign={"left"}
        mb={theme.spacing(5)}
      >
        Please read this before sending
      </Typography>
      <Typography>
        BY USING THE BRIDGE YOU ARE DEEMED TO HAVE:
        (I) READ, UNDERSTOOD AND AGREED TO THE DISCLAIMER BELOW AND THE BRIDGE DOCUMENTATION; AND
        (II) ACKNOWLEDGED THE RISKS ASSOCIATED WITH USING THE BRIDGE AND BLOCKCHAIN TECHNOLOGY.
        <br /><br />
        In particular,
      </Typography>
      <List
        sx={{
          listStyleType: "disc",
          listStyle: "disc",
          pr: theme.spacing(2),
        }}
      >
        {listItems.map((item) => {
          const id = uuidv4();
          return (
            <ListItem sx={{ paddingTop: "4px", paddingBottom: "4px" }} key={id}>
              <ListItemIcon
                sx={{
                  minWidth: "auto",
                }}
              >
                <CircleIcon
                  sx={{
                    mr: theme.spacing(2),
                    fontSize: "8px",
                    color: theme.palette.secondary.contrastText,
                  }}
                />
              </ListItemIcon>

              <ListItemText
                primary={item}
                sx={{ color: theme.palette.text.secondary }}
              />
            </ListItem>
          );
        })}
      </List>
      <Box mt="auto" width="100%">
        <Typography variant="h5" component="p" fontSize="16px">
          <FormControlLabel
            control={<Checkbox />}
            label={` I agree and want to send ${value} ${tokenSymbol} from ${shortenAddress(sender)} on ${sourceNetwork} to ${shortenAddress(receiver)} on ${targetNetwork}.`}
            // value={stored !== undefined}
            onChange={() => setIsAgree(!isAgree)}
            color="default"
            sx={{
              "& .MuiSvgIcon-root": {
                fontSize: 28,
                color: theme.palette.secondary.light,
              },
              "& .Mui-checked svg": {
                fill: theme.palette.secondary.main,
              },
              "& .Mui-checked + .MuiFormControlLabel-label": {
                color: theme.palette.secondary.main,
                fontWeight: 700,
              },
            }}
          />
        </Typography>
      </Box>
      <Box display="flex" flexDirection="column" gap={4} mt={7}>
        <Button
          onClick={start}
          variant="outlined"
          disabled={!isAgree}
          fullWidth
        >
          Start Transfer
        </Button>
        <OutlinedButton onClick={close} variant="outlined" fullWidth>
          Back
        </OutlinedButton>
      </Box>
    </Box>
  );
};

export default PreflightModalTransfer;
